import { SourcePipeConfig } from '../../../interface';
import PushCode from '../../pushSource/key';
import CustomSourceKey from '../../customSource/key';
import newOrderPushPipe from './newOrderPushPipe';

/**
 * 基础分流，主要用于对原始 Push 消息进行加工（自定义消息源为自行编写生产逻辑，因此无需加工）
 */
export const baseBranch: SourcePipeConfig<PushCode, CustomSourceKey> = {
    push: {
        [PushCode.NEW_ORDER_1]: newOrderPushPipe,
    },
} as SourcePipeConfig<PushCode, CustomSourceKey>; // TODO: 不知道为啥 PipeConfig 定义成 Partial 后类型声明就有问题了

export default baseBranch;

export * from './newOrderPushPipe';
